import { render, staticRenderFns } from "./pdfLink.vue?vue&type=template&id=032379a6&scoped=true"
import script from "./pdfLink.vue?vue&type=script&lang=js"
export * from "./pdfLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032379a6",
  null
  
)

export default component.exports